import { TradePosition, TradePositions } from '@sportspredict/shared';
import { TRADE_INTENT_PARAMS } from '@/constants';
import { getCurrentRedirectTarget } from './auth-redirect.util';

export type TradeIntent = Partial<
	Record<(typeof TRADE_INTENT_PARAMS)[keyof typeof TRADE_INTENT_PARAMS], string | null>
>;

export const TRADE_INTENT_PARAM_KEYS = Object.values(TRADE_INTENT_PARAMS);

export function applyTradeIntent(search: URLSearchParams, intent: TradeIntent) {
	const next = new URLSearchParams(search);
	Object.entries(intent).forEach(([key, value]) => {
		if (value) next.set(key, value);
		else next.delete(key);
	});
	return next;
}

export function buildTradeIntentTarget(intent: TradeIntent, target = getCurrentRedirectTarget()) {
	const url = new URL(target, 'http://placeholder');
	const search = applyTradeIntent(url.searchParams, intent).toString();
	return `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
}

export function parseTradeIntentPosition(value: string | null | undefined): TradePosition | null {
	return TradePositions.find((position) => position === value) ?? null;
}
